// prettier-ignore
export class BillType {
    readonly id: number;
    readonly name: string;
    constructor(id: number, name: string) {
        this.id = id;
        this.name = name;
    }

    static PermSubmissionManagementReward = new BillType(40, "submission management reward");
    static PermSubmissionReferralReward = new BillType(160, "submission referral reward");
    static PermInterviewManagementReward = new BillType(190, "interview management reward");
    static PermInterviewReferralReward = new BillType(180, "interview referral reward");

    static PermHireReferralReward = new BillType(20, "hire referred reward");
    static PermHireManagementReward = new BillType(10, "hire managed reward");
    static PermSponsorHireReward = new BillType(30, "sponsor reward");

    static PermAgencySubmissionReward = new BillType(50, "agency submission reward");
    static PermAgencyReferralHireReward = new BillType(70, "agency referral reward");
    static PermAgencyManagementHireReward = new BillType(60, "agency management reward");

    static ContractContractorPay = new BillType(120, "contractor pay");
    static ContractContractorExpenses = new BillType(130, "contractor expenses");
    static ContractSubmissionManagementReward = new BillType(110, "submission management reward");
    static ContractSubmissionReferralReward = new BillType(170, "submission referral reward");
    static ContractHireReferralReward = new BillType(90, "referred hire reward");
    static ContractSponsorReward = new BillType(95, "sponsor reward");
    static ContractHireManagementReward = new BillType(80, "managed hire reward");
    static ContractInterviewManagementReward = new BillType(210, "interview management reward");
    static ContractInterviewReferralReward = new BillType(200, "interview referral reward");

    static PermPromotionReferralReward = new BillType(220, "promotion referral reward");
    static PermPromotionManagementReward = new BillType(230, "promotion management reward");

    static ContractPromotionReferralReward = new BillType(240, "promotion referral reward");
    static ContractPromotionManagementReward = new BillType(250, "promotion management reward");


    static Custom = new BillType(140, "custom payment");

    static asArray = () => [
        BillType.ContractHireManagementReward,
        BillType.ContractHireReferralReward,
        BillType.ContractSubmissionManagementReward,
        BillType.ContractSubmissionReferralReward,
        BillType.ContractInterviewManagementReward,
        BillType.ContractInterviewReferralReward,
        BillType.ContractSponsorReward,
        BillType.ContractContractorPay,
        BillType.ContractContractorExpenses,
        BillType.Custom,
        BillType.PermHireManagementReward,
        BillType.PermHireReferralReward,
        BillType.PermSponsorHireReward,
        BillType.PermSubmissionManagementReward,
        BillType.PermSubmissionReferralReward,
        BillType.PermInterviewManagementReward,
        BillType.PermInterviewReferralReward,
        BillType.PermAgencySubmissionReward,
        BillType.PermAgencyManagementHireReward,
        BillType.PermAgencyReferralHireReward,
        BillType.PermPromotionReferralReward,
        BillType.PermPromotionManagementReward,
        BillType.ContractPromotionReferralReward,
        BillType.ContractPromotionManagementReward,
    ];

    public isPermSubmissionReward = () => BillType.PermSubmissionManagementReward.id === this.id ||
        BillType.PermSubmissionReferralReward.id === this.id;
    public isPermHireReferralReward = () => BillType.PermHireReferralReward.id === this.id;
    public isPermHireManagementReward = () => BillType.PermHireManagementReward.id === this.id;
    public isPermSponsorHireReward = () => BillType.PermSponsorHireReward.id === this.id;
    public isPermAgencySubmissionReward = () => BillType.PermAgencySubmissionReward.id === this.id;
    public isPermAgencyReferralHireReward = () => BillType.PermAgencyReferralHireReward.id === this.id;
    public isPermAgencyManagementHireReward = () => BillType.PermAgencyManagementHireReward.id === this.id;
    public isContractContractorPay = () => BillType.ContractContractorPay.id === this.id;
    public isContractContractorExpenses = () => BillType.ContractContractorExpenses.id === this.id;
    public isContractSubmissionReward = () => BillType.ContractSubmissionManagementReward.id === this.id ||
        BillType.ContractSubmissionReferralReward.id === this.id;
    public isContractHireReferralReward = () => BillType.ContractHireReferralReward.id === this.id;
    public isContractHireManagementReward = () => BillType.ContractHireManagementReward.id === this.id;
    public isContractSponsorReward = () => BillType.ContractSponsorReward.id == this.id;

    public isCustom = () => BillType.Custom.id === this.id;

    public isSubmission = (): boolean =>
        this.isContractSubmissionReward() ||
        this.isPermSubmissionReward() ||
        this.isPermAgencySubmissionReward();

    public isHire = (): boolean => this.isContractHire() || this.isPermHire();

    public isPermHire = (): boolean =>
        this.isPermHireManagementReward() ||
        this.isPermHireReferralReward() ||
        this.isPermSponsorHireReward() ||
        this.isPermAgencyReferralHireReward() ||
        this.isPermAgencyManagementHireReward();

    public isContractHire = (): boolean =>
        this.isContractContractorPay() ||
        this.isContractContractorExpenses() ||
        this.isContractHireManagementReward() ||
        this.isContractHireReferralReward() ||
        this.isContractSponsorReward();

    static fromId = (id: number) => {
        const bt = BillType.asArray().find(t => t.id === id);
        if (!bt) {
            throw new Error(`invalid id requested for bill type: ${id}`);
        }
        return bt;
    };
}
